export const faqBlocks = {
    blocks: [
        {
            block: "mainBlock",
            mainHeader: "Личный кабинет WAY2WEI",
            innerBlocks: [
                {
                    type: "text",
                    value:
                        "Личный кабинет WAY2WEI помогает управлять обучением, доступами, отчётами и настройками аккаунта в одном месте.",
                },
                {
                    type: "h2",
                    value: "Что можно сделать в личном кабинете",
                },
                {
                    type: "list",
                    items: [
                        "Просматривать доступные разделы и сервисы",
                        "Работать с сотрудниками и группами",
                        "Запускать оценку и развитие",
                        "Проверять отчёты и аналитику",
                        "Настраивать уведомления и аккаунт",
                    ],
                },
            ],
        },

        {
            block: "authBlock",
            mainHeader: "Регистрация и вход",
            innerBlocks: [
                {
                    type: "h2",
                    value: "Регистрация",
                },
                {
                    type: "text",
                    value:
                        "После регистрации пользователь получает доступ к личному кабинету в соответствии со своей ролью.",
                },
                {
                    type: "h2",
                    value: "Вход в систему",
                },
                {
                    type: "text",
                    value:
                        "Для входа используйте логин и пароль. Если вход выполняется по внешней ссылке, часть данных может быть подставлена автоматически.",
                },
                {
                    type: "h2",
                    value: "Если не получается войти",
                },
                {
                    type: "list",
                    items: [
                        "Проверьте корректность логина и пароля",
                        "Убедитесь, что пароль не был изменён администратором",
                        "Попробуйте восстановить доступ",
                        "Если ошибка сохраняется, обратитесь в поддержку",
                    ],
                },
            ],
        },

        {
            block: "staffGroupsBlock",
            mainHeader: "Сотрудники и группы",
            innerBlocks: [
                {
                    type: "h2",
                    value: "Работа с сотрудниками",
                },
                {
                    type: "text",
                    value:
                        "В этом разделе можно добавлять сотрудников, редактировать их данные и распределять по группам.",
                },
                {
                    type: "h2",
                    value: "Работа с группами",
                },
                {
                    type: "text",
                    value:
                        "Группы помогают объединять сотрудников для массовых действий, назначения программ и формирования отчётов.",
                },
                {
                    type: "list",
                    items: [
                        "Создание группы",
                        "Добавление и удаление участников",
                        "Редактирование названия и состава",
                        "Использование групп в отчётах и назначениях",
                    ],
                },
            ],
        },

        {
            block: "assessmentDevBlock",
            mainHeader: "Оценка и развитие",
            innerBlocks: [
                {
                    type: "h2",
                    value: "Оценка сотрудников",
                },
                {
                    type: "text",
                    value:
                        "Раздел позволяет запускать оценочные процедуры, отслеживать прогресс и анализировать результаты.",
                },
                {
                    type: "h2",
                    value: "Развитие",
                },
                {
                    type: "text",
                    value:
                        "На основе результатов оценки можно формировать индивидуальные рекомендации и отслеживать развитие компетенций.",
                },
                {
                    type: "list",
                    items: [
                        "Назначение оценки",
                        "Просмотр статусов прохождения",
                        "Анализ результатов",
                        "Формирование рекомендаций по развитию",
                    ],
                },
            ],
        },

        {
            block: "accessControlBlock",
            mainHeader: "Управление доступами",
            innerBlocks: [
                {
                    type: "h2",
                    value: "Назначение доступов",
                },
                {
                    type: "text",
                    value:
                        "Доступы можно выдавать отдельным пользователям или группам в зависимости от доступных ролей и прав.",
                },
                {
                    type: "h2",
                    value: "Изменение прав",
                },
                {
                    type: "text",
                    value:
                        "При изменении роли или задач сотрудника можно скорректировать его права доступа без повторного создания профиля.",
                },
                {
                    type: "list",
                    items: [
                        "Выдача доступа",
                        "Ограничение прав",
                        "Переназначение ролей",
                        "Проверка текущих разрешений",
                    ],
                },
            ],
        },

        {
            block: "ordersBlock",
            mainHeader: "Работа с заказами",
            innerBlocks: [
                {
                    type: "h2",
                    value: "Создание и просмотр заказов",
                },
                {
                    type: "text",
                    value:
                        "В разделе заказов можно отслеживать текущие заявки, их статусы и историю изменений.",
                },
                {
                    type: "h2",
                    value: "Статусы заказов",
                },
                {
                    type: "list",
                    items: [
                        "Черновик",
                        "Отправлен",
                        "В обработке",
                        "Завершён",
                        "Отменён",
                    ],
                },
                {
                    type: "text",
                    value:
                        "Если заказ требует уточнения, его статус может меняться в зависимости от этапа обработки.",
                },
            ],
        },

        {
            block: "notificationsBlock",
            mainHeader: "Настройка уведомлений",
            innerBlocks: [
                {
                    type: "h2",
                    value: "Какие уведомления доступны",
                },
                {
                    type: "text",
                    value:
                        "Пользователь может управлять уведомлениями о событиях в системе, задачах, изменениях статусов и других действиях.",
                },
                {
                    type: "h2",
                    value: "Настройка каналов",
                },
                {
                    type: "list",
                    items: [
                        "Уведомления внутри платформы",
                        "Email-уведомления",
                        "Системные напоминания",
                    ],
                },
            ],
        },

        {
            block: "reportsBlock",
            mainHeader: "Отчёты и аналитика",
            innerBlocks: [
                {
                    type: "text",
                    value:
                        "В разделе отчётов можно анализировать данные по сотрудникам, оценке и финансовым операциям.",
                },

                {
                    type: "section",
                    value: "staff-groups",
                    title: "Сотрудники и группы",
                },
                {
                    type: "text",
                    value:
                        "Отчёты по сотрудникам и группам помогают отслеживать состав команд, распределение по подразделениям и изменения в структуре.",
                },
                {
                    type: "list",
                    items: [
                        "Список сотрудников",
                        "Структура групп",
                        "Распределение по подразделениям",
                        "Изменения состава",
                    ],
                },

                {
                    type: "section",
                    value: "assessment",
                    title: "Оценка и развитие",
                },
                {
                    type: "text",
                    value:
                        "Отчёты по оценке и развитию показывают результаты прохождения, уровень компетенций и динамику прогресса.",
                },
                {
                    type: "list",
                    items: [
                        "Статусы прохождения оценки",
                        "Сводка по результатам",
                        "Динамика развития",
                        "Рекомендации и зоны роста",
                    ],
                },

                {
                    type: "section",
                    value: "finance",
                    title: "Финансовые отчёты",
                },
                {
                    type: "text",
                    value:
                        "Финансовые отчёты позволяют просматривать операции, платежи и итоговые показатели по заказам и услугам.",
                },
                {
                    type: "list",
                    items: [
                        "История операций",
                        "Состояние платежей",
                        "Финансовая сводка",
                        "Экспорт данных для анализа",
                    ],
                },
            ],
        },

        {
            block: "financeBlock",
            mainHeader: "Финансовые операции",
            innerBlocks: [
                {
                    type: "h2",
                    value: "Платежи и операции",
                },
                {
                    type: "text",
                    value:
                        "Раздел предназначен для просмотра и контроля финансовых операций, связанных с использованием платформы.",
                },
                {
                    type: "list",
                    items: [
                        "Просмотр истории платежей",
                        "Проверка статусов операций",
                        "Контроль начислений",
                        "Сверка данных по оплате",
                    ],
                },
            ],
        },

        {
            block: "accountSettingsBlock",
            mainHeader: "Настройки аккаунта",
            innerBlocks: [
                {
                    type: "h2",
                    value: "Личные данные",
                },
                {
                    type: "text",
                    value:
                        "В настройках аккаунта можно обновить персональные данные и изменить параметры входа.",
                },
                {
                    type: "h2",
                    value: "Безопасность",
                },
                {
                    type: "list",
                    items: [
                        "Смена пароля",
                        "Проверка данных профиля",
                        "Настройка уведомлений безопасности",
                    ],
                },
            ],
        },

        {
            block: "supportBlock",
            mainHeader: "Поддержка и помощь",
            innerBlocks: [
                {
                    type: "h2",
                    value: "Как обратиться в поддержку",
                },
                {
                    type: "text",
                    value:
                        "Если у вас возникли вопросы или технические проблемы, вы можете обратиться в службу поддержки через доступные каналы связи.",
                },
                {
                    type: "h2",
                    value: "Когда обращаться",
                },
                {
                    type: "list",
                    items: [
                        "Не удаётся войти в систему",
                        "Не отображаются нужные данные",
                        "Ошибка при работе с заказами или отчётами",
                        "Нужна консультация по функционалу",
                    ],
                },
            ],
        },
    ],
};